<template>
    <div class="bill-item-option-group">
        <div class="name" v-if="optionGroup.displayName || props.forceDisplayGroupName">
            {{ getNameInLocationLanguage(optionGroup, props.showInternalNames) }}
        </div>
        <div class="entries" v-if="optionGroup.items.length">
            <BillItemOption
                v-for="option in optionGroup.items"
                :key="option.id"
                :option="option"
                :multiplier="multiplier"
                :inactive="inactive"
                :showInternalNames="props.showInternalNames"
                :allowDiscountRemoval="props.allowDiscountRemoval"
                :forceDisplayGroupName="props.forceDisplayGroupName"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { IBillItemOptionGroup } from "@/data/model/Bill";
    import { getNameInLocationLanguage } from "@/shared/helpers/ItemNameHelper";

    import BillItemOption from "./BillItemOption.vue";

    const props = defineProps<{
        optionGroup: IBillItemOptionGroup;
        multiplier: number;
        inactive?: boolean;
        showInternalNames: boolean;
        allowDiscountRemoval: boolean;
        forceDisplayGroupName?: boolean;
    }>();
</script>

<style lang="scss">
    .bill-item-option-group {
        font-size: 12px;

        > .name {
            font-style: italic;
            line-height: 1.5em;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
</style>
